<template>
  <div class="grid">
    <header>
      <TopNav/>
    </header>
    <main class="container is-fluid">
      <section class="section">
        <div class="columns is-centered">
          <div class="column is-two-thirds-desktop is-half-widescreen">
            <article class="campaigns" v-for="(campaign, idx) in campaigns" :key="idx">
              <CampaignCard 
              :campaignId="campaign.id" 
              :name="campaign.name"
              :creatorId="campaign.createdBy"/>
            </article>
          </div>
        </div>
      </section>
      <section class="section">
        <div class="columns is-centered">
          <div class="column is-half-desktop is-two-fifths-widescreen">
            <form class="box" @submit.prevent="addCampaign(name)">
              <h2 class="title is-5 is-size-4-desktop">
                Create a New Campaign
              </h2>
              <div class="field has-addons">
                <p class="control is-expanded has-icons-left">
                  <input 
                  v-model="name" 
                  placeholder="Campaign Name" 
                  class="input is-rounded is-medium" 
                  required>
                  <span class="icon is-left">
                    <i class="fas fa-dungeon"></i>
                  </span>
                </p>
                <p class="control">
                  <button type="submit" class="button is-rounded is-info is-medium">Create</button>
                </p>
              </div>
            </form>
          </div>
        </div>
      </section>
    </main>
    <footer> 
      <InfoFooter/>
    </footer>
  </div>
</template>
<script>
import { db } from '../main'
import {mapGetters} from 'vuex'
import TopNav from '../components/TopNav'
import CampaignCard from '../components/CampaignCard'
import InfoFooter from '../components/InfoFooter'
export default {
  name: 'List',
  data () {
    return {
      campaigns: [],
      name: '',
    }
  },
  firestore () {
    this.$bind('campaigns', db.collection('campaigns').orderBy('createdAt', 'desc'))
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    addCampaign (title) {
      const name = this.titleCase(title)
      const createdAt = new Date()
      const createdBy = this.user.uid
      // const party = []
      db.collection('campaigns')
      .add({ 
        name, 
        createdAt, 
        createdBy 
      })
      // Clear values
      this.name = ''
    },
    deleteCampaign (id) {
      db.collection('campaigns')
      .doc(id)
      .delete()
    },
    enterCampaign (campaignId) {
      const cid = campaignId
      console.log(cid)
      this.$router.push({ 
        name: 'Campaign', 
        params: {
          id: cid
        } 
      })
    },
  },
  components: {
    CampaignCard,
    TopNav,
    InfoFooter
  }
}
</script>
<style scoped>
.campaigns:not(:last-child) {
  margin: 0 0 2em;
}
</style>


// WEBPACK FOOTER //
// src/views/List.vue